import { useTranslation } from "react-i18next";

import { Modal } from "../../../../shared/ui/modal";
import { useCreateCourses } from "../../../center";
import type { CourseInput } from "../../../center";
import { COURSE_COLUMNS, readCourses } from "../../domain/csvImports";
import { COURSE_ERRORS } from "../refusals";
import CsvImportPanel from "../../../../shared/ui/csv/CsvImportPanel";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    centerId: string;
}

// One course over two rows: the course's names repeat on each of its phases.
const TEMPLATE_ROWS = [
    [
        "Formación en Terapia Gestalt",
        "GES-2026-FDS",
        "Fundamentos",
        "Bases teóricas del enfoque",
        "2026-10-01",
        "2027-01-31",
        "Awareness|Contacto|Ciclo de la experiencia",
        "Primer trimestre",
    ],
    [
        "Formación en Terapia Gestalt",
        "GES-2026-FDS",
        "Práctica supervisada",
        "Trabajo en grupo con supervisión",
        "2027-02-01",
        "2027-06-30",
        "Supervisión|Casos",
        "Segundo y tercer trimestre",
    ],
];

/** Creating many courses, each with its plan, from a spreadsheet of one row per phase. */
export default function CourseImportModal({ isOpen, onClose, centerId }: Props) {
    const { t } = useTranslation();
    const createMany = useCreateCourses(centerId);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            ariaLabel={t("center.csv.courses.title")}
            className="mx-4 max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-surface-raised p-6"
        >
            <h3 className="text-lg font-semibold text-content-primary">{t("center.csv.courses.title")}</h3>
            <p className="mb-5 mt-1 text-sm text-content-tertiary">{t("center.csv.courses.subtitle")}</p>
            <CsvImportPanel<CourseInput>
                columns={COURSE_COLUMNS}
                read={readCourses}
                templateName="cursos"
                templateRows={TEMPLATE_ROWS}
                onImport={(courses) => createMany.mutateAsync(courses)}
                describe={(course) => course.internal_name ?? ""}
                errorMessage={(code) => t(COURSE_ERRORS[code] ?? "center.courses.errorGeneric")}
                submitLabel={(count) => t("center.csv.courses.submit", { count })}
            />
        </Modal>
    );
}
